import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import store from "../../../store/store";

const AdminRoute = props => {
  const { auth } = store.getState();
  const profile = auth?.user?.role;

  const [returnedRoute, setReturnedRoute] = useState("");
  useEffect(() => {
    switch (props.permissionLevel) {
      case "ADMIN":
        return setReturnedRoute(
          profile === "ADMIN" || props.roleType === "ADMIN" ? (
            <Route {...props} />
          ) : (
            <Redirect to="/admin/error" />
          )
        );
      default:
        return setReturnedRoute(<Route {...props} />);
    }
  }, [props, profile]);
  return <>{returnedRoute}</>;
};

const mapStateToProps = ({ auth }) => ({
  roleType: auth.role?.name
});

export default connect(mapStateToProps, null)(AdminRoute);
